module.exports = __webpack_public_path__ + "img/topicTwo_n.1171c74f.svg";